<nz-skeleton [nzLoading]="isLoading" nzActive="true"></nz-skeleton>
<nz-form-label *ngIf="!isLoading" [attr.nzFor]="fieldCode" [hidden]="hideTitle" [id]="labelId" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup" *ngIf="!isLoading">
    <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="placeHolder" [id]="fieldCode"
        [(ngModel)]="currentSelect" nzSize="large" style="width: 100%" (ngModelChange)="changeSelect($event)"
        [formControlName]="formFieldInfo.fieldCode" [nzLoading]="isLoading"
        [attr.Title] = "shortTitle"
        [ngClass] = "fieldCode"
        [attr.condition]="formFieldConfig && formFieldConfig.condition"
        [attr.conditionExtend]="formFieldConfig && formFieldConfig.conditionExtend">
        <nz-option *ngFor="let item of data" [nzLabel]="item.dataTextField" [nzValue]="item" nzSize="large"></nz-option>
    </nz-select>
</nz-form-control>